import { render, staticRenderFns } from "./customEffctItem.vue?vue&type=template&id=287cf2e2&scoped=true"
import script from "./customEffctItem.vue?vue&type=script&lang=js"
export * from "./customEffctItem.vue?vue&type=script&lang=js"
import style0 from "./customEffctItem.vue?vue&type=style&index=0&id=287cf2e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287cf2e2",
  null
  
)

export default component.exports